import { render } from "./ChangelogPage.vue?vue&type=template&id=322fcf74&scoped=true"
import script from "./ChangelogPage.vue?vue&type=script&lang=js"
export * from "./ChangelogPage.vue?vue&type=script&lang=js"

import "./ChangelogPage.vue?vue&type=style&index=0&id=322fcf74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322fcf74"]])

export default __exports__